import React from 'react'
import { PropTypes } from 'prop-types'
const TransitIcon = (props) => (
  <svg
    id="Layer_2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16.37 19.44"
    fill={props.fill ? props.fill : '#262626;'}
    width={props.width ? props.width : '30'}
    height={props.height ? props.height : '30'}
  >
    <g id="Layer_1-2">
      <path
        className="cls-1"
        d="m2.28,19.44c-.22,0-.42-.06-.59-.19s-.26-.29-.26-.5v-2.15c-.49-.27-.86-.67-1.09-1.18s-.35-1.06-.35-1.64V3.63C0,2.37.65,1.45,1.96.87c1.3-.58,3.39-.87,6.25-.87s4.9.29,6.2.87c1.3.58,1.96,1.5,1.96,2.76v10.16c0,.58-.12,1.13-.35,1.64s-.59.9-1.09,1.18v2.15c0,.2-.09.37-.26.5s-.37.19-.59.19h-.49c-.24,0-.44-.06-.61-.19s-.26-.29-.26-.5v-1.41H3.63v1.41c0,.2-.09.37-.26.5s-.38.19-.61.19h-.49ZM8.21,2.97h6.63H1.53h6.68Zm4.53,7.5H1.53h13.3-2.1Zm-11.2-1.53h13.3v-4.43H1.53v4.43Zm2.71,5.6c.39,0,.72-.14,1-.41s.41-.61.41-1-.14-.72-.41-1-.61-.41-1-.41-.72.14-1,.41-.41.61-.41,1,.14.72.41,1,.61.41,1,.41Zm7.88,0c.39,0,.72-.14,1-.41s.41-.61.41-1-.14-.72-.41-1-.61-.41-1-.41-.72.14-1,.41-.41.61-.41,1,.14.72.41,1,.61.41,1,.41ZM1.53,2.97h13.3c-.41-.44-1.19-.79-2.35-1.05s-2.58-.38-4.27-.38c-2.01,0-3.56.12-4.63.35s-1.76.59-2.05,1.09Zm2.1,12.84h9.11c.6,0,1.1-.23,1.5-.69s.6-.99.6-1.59v-3.07H1.53v3.07c0,.6.2,1.13.6,1.59.4.46.9.69,1.5.69Z"
      />
    </g>
  </svg>
)

export default TransitIcon
TransitIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
}
